/**
 * @desc 请款人补充附件
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.PayUploadFileRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentMaster/uploadFileByInitiator`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
